/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. */

// @flow

export const FF: {
  ANATOMIC_NAVIGATOR: 'ANATOMIC_NAVIGATOR',
  DEFAULT_WORKLIST_DATE_RANGE_DAYS_OFFSET: 'DEFAULT_WORKLIST_DATE_RANGE_DAYS_OFFSET',
  DISCARD_REPORT_ENABLED: 'DISCARD_REPORT_ENABLED',
  ENABLE_REPORTER_SUBMISSION: 'ENABLE_REPORTER_SUBMISSION',
  GSPS_ANNOTATIONS: 'GSPS_ANNOTATIONS',
  HANGING_PROTOCOL_DESERIALIZATION: 'HANGING_PROTOCOL_DESERIALIZATION',
  HANGING_PROTOCOL_VERSION: 'HANGING_PROTOCOL_VERSION',
  HIDE_VIEWPORT_LOADING_PROGRESS_BAR: 'HIDE_VIEWPORT_LOADING_PROGRESS_BAR',
  HIDE_VIEWPORT_LOADING_PROGRESS_PERCENTAGE: 'HIDE_VIEWPORT_LOADING_PROGRESS_PERCENTAGE',
  IMAGE_BOOKMARK: 'IMAGE_BOOKMARK',
  LAYOUT_CONFIG: 'LAYOUT_CONFIG',
  LOADING_PRIORITY_ACTIVE: 'LOADING_PRIORITY_ACTIVE',
  LOADING_PRIORITY_HANGED: 'LOADING_PRIORITY_HANGED',
  LOADING_PRIORITY_LINKED: 'LOADING_PRIORITY_LINKED',
  LOADING_PRIORITY_PREFETCHING: 'LOADING_PRIORITY_PREFETCHING',
  LOADING_PRIORITY_UNHANGED: 'LOADING_PRIORITY_UNHANGED',
  LUNG_WORKFLOW: 'LUNG_WORKFLOW',
  MIN_COLUMNS_TO_ENABLE_MULTIPLE_EXPANSION_AREAS: 'MIN_COLUMNS_TO_ENABLE_MULTIPLE_EXPANSION_AREAS',
  NVOQ_ENVIRONMENT: 'NVOQ_ENVIRONMENT',
  PICK_OPTION_BY_NAME: 'PICK_OPTION_BY_NAME',
  PREFETCH_CLAIMED_WORKLIST_ITEMS: 'PREFETCH_CLAIMED_WORKLIST_ITEMS',
  PREFETCH_HOVERED_WORKLIST_ITEM: 'PREFETCH_HOVERED_WORKLIST_ITEM',
  PREFETCH_READ_CASE_ITEM: 'PREFETCH_READ_CASE_ITEM',
  PREFETCH_TOP_WORKLIST_ITEMS: 'PREFETCH_TOP_WORKLIST_ITEMS',
  PREFETCH_TOP_WORKLIST_ITEMS_BIG_BATCHING: 'PREFETCH_TOP_WORKLIST_ITEMS_BIG_BATCHING',
  PREFETCH_TOP_WORKLIST_ITEMS_LARGE: 'PREFETCH_TOP_WORKLIST_ITEMS_LARGE',
  PROGRESIVE_RENDER_BATCH_SIZE: 'PROGRESIVE_RENDER_BATCH_SIZE',
  REPORTER_AI_MODE: 'REPORTER_AI_MODE',
  REPORTER_ANATOMIC_NAVIGATOR: 'REPORTER_ANATOMIC_NAVIGATOR',
  REPORTER_ASR_PLEX: 'REPORTER_ASR_PLEX',
  REPORTER_AUDIO_QUALITY_NOTIFICATIONS: 'REPORTER_AUDIO_QUALITY_NOTIFICATIONS',
  REPORTER_AUTOCORRECT_ENABLED: 'REPORTER_AUTOCORRECT_ENABLED',
  REPORTER_AUTOCORRECT_DICTATION_ENABLED: 'REPORTER_AUTOCORRECT_DICTATION_ENABLED',
  REPORTER_BRACKET_STYLE_NEW: 'REPORTER_BRACKET_STYLE_NEW',
  REPORTER_ENABLE_LINK_CASES: 'REPORTER_ENABLE_LINK_CASES',
  REPORTER_ALWAYS_ON_MEDIA_STREAM: 'REPORTER_ALWAYS_ON_MEDIA_STREAM',
  REPORTER_EXPERIMENTAL_OPTIONS: 'REPORTER_EXPERIMENTAL_OPTIONS',
  REPORTER_MERGE_FIELD_SETTINGS: 'REPORTER_MERGE_FIELD_SETTINGS',
  REPORTER_RATINGS: 'REPORTER_RATINGS',
  REPORTER_SHOW_DICTATION_STEP_NOTIFICATIONS: 'REPORTER_SHOW_DICTATION_STEP_NOTIFICATIONS',
  REPORTER_SINGLE_WEBSOCKET_DICTATION: 'REPORTER_SINGLE_WEBSOCKET_DICTATION',
  REPORTER_RECORDING_STOP_DELAY: 'REPORTER_RECORDING_STOP_DELAY',
  REPORTER_VOCABULARY_EDITOR_ENABLED: 'REPORTER_VOCABULARY_EDITOR_ENABLED',
  REPORT_CONTENT_UNMASKED: 'REPORT_CONTENT_UNMASKED',
  REPORT_OUTLINE: 'REPORT_OUTLINE',
  REQUEST_NODULE_MSI: 'REQUEST_NODULE_MSI',
  SDK_LENGTH_TOOL: 'SDK_LENGTH_TOOL',
  SHOW_MOUSE_SENSITIVITY_SETTINGS: 'SHOW_MOUSE_SENSITIVITY_SETTINGS',
  SLATE_OPS_LOG: 'SLATE_OPS_LOG',
  UNIFIED_EDITOR_PHASE_TWO: 'UNIFIED_EDITOR_PHASE_TWO',
  URT_ENABLED: 'URT_ENABLED',
  USE_BACKEND_INSTANCE_ORDERING: 'USE_BACKEND_INSTANCE_ORDERING',
  USE_PROGRESSIVE_RENDERING: 'USE_PROGRESSIVE_RENDERING',
  USE_INVERTED_IMAGE_DETECTION: 'USE_INVERTED_IMAGE_DETECTION',
  TEMP_REPORT_ENABLED: 'TEMP_REPORT_ENABLED',
  VIEWER_DATA_REFETCH: 'VIEWER_DATA_REFETCH',
  VIEWER_TRANSFER_TYPE: 'VIEWER_TRANSFER_TYPE',
  VIEWER_TRANSFER_PROTOCOL: 'VIEWER_TRANSFER_PROTOCOL',
  WORKLIST_VIEWS_DRAWER: 'WORKLIST_VIEWS_DRAWER',
  refresh_viewer_on_new_case: 'refresh_viewer_on_new_case',
  MULTI_FACTOR_AUTHENTICATION: 'MULTI_FACTOR_AUTHENTICATION',
  VIEWPORT_TYPE_THREE_D_DRE_ENABLED: 'VIEWPORT_TYPE_THREE_D_DRE_ENABLED',
  USE_PIXEL_WORKER_WINDOW: 'USE_PIXEL_WORKER_WINDOW',
} = {
  ANATOMIC_NAVIGATOR: 'ANATOMIC_NAVIGATOR',
  DEFAULT_WORKLIST_DATE_RANGE_DAYS_OFFSET: 'DEFAULT_WORKLIST_DATE_RANGE_DAYS_OFFSET',
  DISCARD_REPORT_ENABLED: 'DISCARD_REPORT_ENABLED',
  ENABLE_REPORTER_SUBMISSION: 'ENABLE_REPORTER_SUBMISSION',
  GSPS_ANNOTATIONS: 'GSPS_ANNOTATIONS',
  HANGING_PROTOCOL_DESERIALIZATION: 'HANGING_PROTOCOL_DESERIALIZATION',
  HANGING_PROTOCOL_VERSION: 'HANGING_PROTOCOL_VERSION',
  HIDE_VIEWPORT_LOADING_PROGRESS_BAR: 'HIDE_VIEWPORT_LOADING_PROGRESS_BAR',
  HIDE_VIEWPORT_LOADING_PROGRESS_PERCENTAGE: 'HIDE_VIEWPORT_LOADING_PROGRESS_PERCENTAGE',
  IMAGE_BOOKMARK: 'IMAGE_BOOKMARK',
  LAYOUT_CONFIG: 'LAYOUT_CONFIG',
  LOADING_PRIORITY_ACTIVE: 'LOADING_PRIORITY_ACTIVE',
  LOADING_PRIORITY_HANGED: 'LOADING_PRIORITY_HANGED',
  LOADING_PRIORITY_LINKED: 'LOADING_PRIORITY_LINKED',
  LOADING_PRIORITY_PREFETCHING: 'LOADING_PRIORITY_PREFETCHING',
  LOADING_PRIORITY_UNHANGED: 'LOADING_PRIORITY_UNHANGED',
  LUNG_WORKFLOW: 'LUNG_WORKFLOW',
  MIN_COLUMNS_TO_ENABLE_MULTIPLE_EXPANSION_AREAS: 'MIN_COLUMNS_TO_ENABLE_MULTIPLE_EXPANSION_AREAS',
  NVOQ_ENVIRONMENT: 'NVOQ_ENVIRONMENT',
  PICK_OPTION_BY_NAME: 'PICK_OPTION_BY_NAME',
  PREFETCH_CLAIMED_WORKLIST_ITEMS: 'PREFETCH_CLAIMED_WORKLIST_ITEMS',
  PREFETCH_HOVERED_WORKLIST_ITEM: 'PREFETCH_HOVERED_WORKLIST_ITEM',
  PREFETCH_READ_CASE_ITEM: 'PREFETCH_READ_CASE_ITEM',
  PREFETCH_TOP_WORKLIST_ITEMS: 'PREFETCH_TOP_WORKLIST_ITEMS',
  PREFETCH_TOP_WORKLIST_ITEMS_BIG_BATCHING: 'PREFETCH_TOP_WORKLIST_ITEMS_BIG_BATCHING',
  PREFETCH_TOP_WORKLIST_ITEMS_LARGE: 'PREFETCH_TOP_WORKLIST_ITEMS_LARGE',
  PROGRESIVE_RENDER_BATCH_SIZE: 'PROGRESIVE_RENDER_BATCH_SIZE',
  REPORTER_AI_MODE: 'REPORTER_AI_MODE',
  REPORTER_ANATOMIC_NAVIGATOR: 'REPORTER_ANATOMIC_NAVIGATOR',
  REPORTER_ASR_PLEX: 'REPORTER_ASR_PLEX',
  REPORTER_AUDIO_QUALITY_NOTIFICATIONS: 'REPORTER_AUDIO_QUALITY_NOTIFICATIONS',
  REPORTER_AUTOCORRECT_ENABLED: 'REPORTER_AUTOCORRECT_ENABLED',
  REPORTER_AUTOCORRECT_DICTATION_ENABLED: 'REPORTER_AUTOCORRECT_DICTATION_ENABLED',
  REPORTER_BRACKET_STYLE_NEW: 'REPORTER_BRACKET_STYLE_NEW',
  REPORTER_ENABLE_LINK_CASES: 'REPORTER_ENABLE_LINK_CASES',
  REPORTER_ALWAYS_ON_MEDIA_STREAM: 'REPORTER_ALWAYS_ON_MEDIA_STREAM',
  REPORTER_EXPERIMENTAL_OPTIONS: 'REPORTER_EXPERIMENTAL_OPTIONS',
  REPORTER_MERGE_FIELD_SETTINGS: 'REPORTER_MERGE_FIELD_SETTINGS',
  REPORTER_RATINGS: 'REPORTER_RATINGS',
  REPORTER_SHOW_DICTATION_STEP_NOTIFICATIONS: 'REPORTER_SHOW_DICTATION_STEP_NOTIFICATIONS',
  REPORTER_SINGLE_WEBSOCKET_DICTATION: 'REPORTER_SINGLE_WEBSOCKET_DICTATION',
  REPORTER_RECORDING_STOP_DELAY: 'REPORTER_RECORDING_STOP_DELAY',
  REPORTER_VOCABULARY_EDITOR_ENABLED: 'REPORTER_VOCABULARY_EDITOR_ENABLED',
  REPORT_CONTENT_UNMASKED: 'REPORT_CONTENT_UNMASKED',
  REPORT_OUTLINE: 'REPORT_OUTLINE',
  REQUEST_NODULE_MSI: 'REQUEST_NODULE_MSI',
  SDK_LENGTH_TOOL: 'SDK_LENGTH_TOOL',
  SHOW_MOUSE_SENSITIVITY_SETTINGS: 'SHOW_MOUSE_SENSITIVITY_SETTINGS',
  SLATE_OPS_LOG: 'SLATE_OPS_LOG',
  UNIFIED_EDITOR_PHASE_TWO: 'UNIFIED_EDITOR_PHASE_TWO',
  URT_ENABLED: 'URT_ENABLED',
  USE_BACKEND_INSTANCE_ORDERING: 'USE_BACKEND_INSTANCE_ORDERING',
  USE_PROGRESSIVE_RENDERING: 'USE_PROGRESSIVE_RENDERING',
  USE_INVERTED_IMAGE_DETECTION: 'USE_INVERTED_IMAGE_DETECTION',
  TEMP_REPORT_ENABLED: 'TEMP_REPORT_ENABLED',
  VIEWER_DATA_REFETCH: 'VIEWER_DATA_REFETCH',
  VIEWER_TRANSFER_TYPE: 'VIEWER_TRANSFER_TYPE',
  VIEWER_TRANSFER_PROTOCOL: 'VIEWER_TRANSFER_PROTOCOL',
  WORKLIST_VIEWS_DRAWER: 'WORKLIST_VIEWS_DRAWER',
  refresh_viewer_on_new_case: 'refresh_viewer_on_new_case',
  MULTI_FACTOR_AUTHENTICATION: 'MULTI_FACTOR_AUTHENTICATION',
  VIEWPORT_TYPE_THREE_D_DRE_ENABLED: 'VIEWPORT_TYPE_THREE_D_DRE_ENABLED',
  USE_PIXEL_WORKER_WINDOW: 'USE_PIXEL_WORKER_WINDOW',
};
export type FeatureFlag = $Values<typeof FF>;
